var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.6276C17.5 14.2097 17.5 15.7917 17.5 17.3737C17.5 18.068 16.9615 18.6257 16.2912 18.6257C14.7637 18.6257 13.2363 18.6257 11.7088 18.6257C11.0385 18.6257 10.5 18.068 10.5 17.3737C10.5 15.7917 10.5 14.2097 10.5 12.6276C10.5 11.9334 11.0385 11.3757 11.7088 11.3757C13.2363 11.3757 14.7637 11.3757 16.2912 11.3757C16.9615 11.3757 17.5 11.9447 17.5 12.6276Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 5.9375L17.5 3.21875M14.875 5.9375L17.5 8.65625M14.875 5.9375C14.875 5.9375 18.8125 5.48438 21 7.29688C23.1875 9.10938 23.625 11.375 23.625 11.375",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 24.0625L10.5 26.7812M13.125 24.0625L10.5 21.3438M13.125 24.0625C13.125 24.0625 9.1875 24.5156 7 22.7031C4.8125 20.8906 4.375 18.625 4.375 18.625",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrient);
export default __webpack_public_path__ + "static/media/orient.0f2f8b8f76ca253412ab8c6bb799eb8c.svg";
export { ForwardRef as ReactComponent };